import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ChangeHistoryService } from '@nimbus-library/features/change-history/change-history.service';
import { LoggingContextService } from '@nimbus-library/features/logger/services/logging-context.service';
import { APP_CONFIG, IAppConfiguration } from '@nimbus-library/features/shared/services/base-http/app.configuration';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { HttpStrategyResolver } from '@nimbus-library/features/shared/services/base-http/http-stratagy.resolver';
import { IHttpStrategy } from '@nimbus-library/features/shared/services/base-http/i-http.strategy';

@Injectable({ providedIn: 'root' })
export class SharedHttpService extends BaseHttpService {
  public get http(): IHttpStrategy {
    return this.httpStrategyResolver.getStrategy();
  }

  public constructor(
    http: HttpClient,
    private readonly httpStrategyResolver: HttpStrategyResolver,
    @Inject(APP_CONFIG) config: IAppConfiguration,
  ) {
    super(
      http,
      config.baseApiUrl,
      () => LoggingContextService.getContext(),
      () => ChangeHistoryService.getHeaders(),
    );
  }
}
